import { useContext } from 'react';

import { CrossdockingContext } from '../context/CrossdockingContext';

export default function useCrossdockingContext() {
  const ctx = useContext(CrossdockingContext);
  if (!ctx) {
    throw new Error(
      'CrossdockingContext must be used within a CrossdockingContext'
    );
  }
  return ctx;
}
